<template>
  <footer class="relative bg-gray-300 pt-8 pb-6">
    <div
      class="bottom-auto top-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden -mt-20"
      style="height: 80px; transform: translateZ(0px);"
    >
      <svg
        class="absolute bottom-0 overflow-hidden"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="none"
        viewBox="0 0 2560 100"
        x="0"
        y="0"
      >
        <polygon
          class="text-gray-300 fill-current"
          points="3200 0 3200 100 0 100"
        ></polygon>
      </svg>
    </div>
    <div class="container mx-auto px-4">
      <div class="flex flex-wrap">
        <div class="w-full lg:w-6/12 px-4">
          <h4 class="text-3xl font-semibold">{{ this.getText('greetings') }}!</h4>
          <h5 class="text-lg mt-0 mb-2 text-gray-700 font-semibold pt-2">
            {{ this.getText('find-me-1') }}
            <router-link :to="this.getRouteUrl('contacts')"
                         type="button"
                         style="text-decoration: underline">
              {{ this.getText('find-me-2') }}
            </router-link>
          </h5>
        </div>
        <div class="w-full lg:w-6/12 px-4">
          <div class="flex flex-wrap items-top mb-6">
            <div class="w-full lg:w-4/12 px-0 md:px-4 pt-8 md:pt-0 ml-auto">
              <span class="block uppercase text-gray-600 text-sm font-semibold mb-2">
                {{ this.getText('useful-links') }}
              </span>
              <ul class="list-unstyled">
                <li>
                  <a
                    class="text-gray-700 hover:text-gray-900 font-semibold block pb-2 text-sm"
                    href="https://company.lursoft.lv/arhetips/40003263531"
                    >Arhetips Lursoft</a
                  >
                </li>
                <li>
                  <a
                    class="text-gray-700 hover:text-gray-900 font-semibold block pb-2 text-sm"
                    href="https://company.lursoft.lv/gsa-projekts/40003773040"
                    >GSA-Projekts Lursoft</a
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <hr class="my-6 border-gray-400" />
      <p class="text-sm pl-4">{{ this.getText('page-author') }}: Dāvis Dieziņš</p>
    </div>
  </footer>
</template>
<script>
  import {mapGetters} from 'vuex'

export default {
  data() {
    return {
      date: new Date().getFullYear()
    }
  },
  computed: {
    ...mapGetters(['getText', 'getRouteUrl'])
  },
}
</script>
